<template>
  <div class="index-page">
    <div class="main-content">
      <Banner />
      <BrandCatalogue />
      <LatestShipments />
      <HelpBanner />
      <PopularProducts />
      <ServiceWorkflow />
    </div>
  </div>
</template>

<script>
import Banner from './coms/Banner.vue'
import BrandCatalogue from './coms/BrandCatalogue.vue'
import LatestShipments from './coms/LatestShipments.vue'
import HelpBanner from './coms/HelpBanner.vue'
import PopularProducts from './coms/PopularProducts.vue'
import ServiceWorkflow from './coms/ServiceWorkflow.vue'

export default {
  name: 'IndexPage',
  components: {
    Banner,
    BrandCatalogue,
    LatestShipments,
    HelpBanner,
    PopularProducts,
    ServiceWorkflow
  }
}
</script>

<style scoped>
.index-page {
  width: 100%;
  flex: 1;
  background-color: #fff;
}

.main-content {
  width: 100%;
}
</style>
